import { Stack, Typography } from '@mui/material';
import { RadioButtons } from 'Components/RadioButtons';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { REASONS } from 'Enum/Feedback';
import { useDictionary } from 'Hooks';

interface IReason {
  reasonValue: REASONS | '';
  setReasonValue: (value: REASONS | '') => void;
  isReasonError: boolean;
}

export const Reason = ({
  reasonValue,
  setReasonValue,
  isReasonError,
}: IReason) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback).reason;

  return (
    <Stack gap='24px' width='fit-content'>
      <Typography
        color={isReasonError ? '#E12D2D' : undefined}
        maxWidth='600px'
        id='reason-label'
        variant='body2'
      >
        {dictionary.reasonIs}
      </Typography>
      {isReasonError && (
        <Typography
          color='#E12D2D'
          id='reason-error'
          role='alert'
          aria-live='assertive'
          variant='body6'
          mt='-20px'
          mb='-10px'
          whiteSpace={'nowrap'}
        >
          {dictionary.errorMessage}
        </Typography>
      )}
      <RadioButtons
        options={Object.values(REASONS)}
        setValue={(value) => setReasonValue(value as REASONS | '')}
        value={reasonValue}
        labelledby={isReasonError ? 'reason-error' : 'reason-label'}
      />
    </Stack>
  );
};
